<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>
    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>
      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Revenue <span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>

      <div class="mainDivBody">
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadRevenueReport(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
          <div class="divider ">
            <hr>
          </div>
          <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
           <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                    (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                    (onChange)="getCities($event)" placeholder="Select State" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                  <li>
                  <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                    (onChange)="loadRevenueReport(lastTableLazyLoadEvent)" placeholder="Select City" optionLabel="name"
                    optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="cityName"></p-dropdown>
                </li> 
                <li>
                    <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                    (onChange)="applySportFilter()" placeholder="Select Sport" optionLabel="name"
                    optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="sportName"></p-dropdown>
                </li>
                
              
              </ul>
            </div>
          </div> 
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="revenueReportsData" [autoLayout]="true" [paginator]="true"
              [rows]="10" [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadRevenueReport($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="CityNameTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="city">
                    <div class="p-d-flex p-jc-between p-ai-center"> City <p-sortIcon field="city"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="state" class="StateTd">
                    <div class="p-d-flex p-jc-between p-ai-center"> State <p-sortIcon field="state"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="country" class="countryTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Country <p-sortIcon field="country"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="academySubscriptionFee">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Subscription Fee <p-sortIcon
                        field="academySubscriptionFee"></p-sortIcon>
                    </div>
                  </th>
                  <!-- <th class="" pSortableColumn="tds"><div class="p-d-flex p-jc-between p-ai-center"> TDS <p-sortIcon field="tds"></p-sortIcon></div></th> -->
                  <!-- <th class="CommissionTD" pSortableColumn="commission">
                      <div class="p-d-flex p-jc-between p-ai-center"> Commission <p-sortIcon field="commission"></p-sortIcon>
                      </div>
                    </th> -->
                  <th class="userSubscriptionFeeTD" pSortableColumn="userSubscriptionFee">
                    <div class="p-d-flex p-jc-between p-ai-center"> User Subscription Fee <p-sortIcon
                        field="userSubscriptionFee"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tournamentRegistrations"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament Registrations <p-sortIcon
                        field="tournamentRegistrations"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BookingsTd" pSortableColumn="courtBookings">
                    <div class="p-d-flex p-jc-between p-ai-center"> Court Bookings <p-sortIcon
                        field="courtBookings"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="academyRegistration"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Registration <p-sortIcon
                        field="academyRegistration"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="findAPartner"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Find A Partner <p-sortIcon
                        field="findAPartner"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="eStore"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> E Store <p-sortIcon
                        field="eStore"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="totalRevenue"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Total Revenue <p-sortIcon
                        field="totalRevenue"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th pfrozencolumn="" class="CityNameTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'city', 'contains')"
                      [value]="dt.filters['city'] ? dt.filters['city'].value : ''" />
                  </th>

                  <th class="StateTd" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'state', 'contains')"
                      [value]="dt.filters['state'] ? dt.filters['state'].value : ''" />
                  </th>
                  <th class="countryTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'country', 'contains')"
                      [value]="dt.filters['country'] ? dt.filters['country'].value : ''" />
                  </th>
                  <th class="registrationDateTD p-element text-nowrap" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academySubscriptionFee', 'contains')"
                      [value]="dt.filters['academySubscriptionFee'] ? dt.filters['academySubscriptionFee'].value : ''" />
                  </th>
                  <th class="userSubscriptionFeeTD p-element text-nowrap"
                    style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userSubscriptionFee', 'contains')"
                      [value]="dt.filters['userSubscriptionFee'] ? dt.filters['userSubscriptionFee'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentRegistrations', 'contains')"
                      [value]="dt.filters['tournamentRegistrations'] ? dt.filters['tournamentRegistrations'].value : ''" />
                  </th>
                  <th class="BookingsTd show-col">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'courtBookings', 'contains')"
                      [value]="dt.filters['courtBookings'] ? dt.filters['courtBookings'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyRegistration', 'contains')"
                      [value]="dt.filters['academyRegistration'] ? dt.filters['academyRegistration'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'findAPartner', 'contains')"
                      [value]="dt.filters['findAPartner'] ? dt.filters['findAPartner'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'eStore', 'contains')"
                      [value]="dt.filters['eStore'] ? dt.filters['eStore'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'totalRevenue', 'contains')"
                      [value]="dt.filters['totalRevenue'] ? dt.filters['totalRevenue'].value : ''" />
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-revenueReportList>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="CityNameTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{revenueReportList?.city}}" tooltipPosition="bottom">
                      {{revenueReportList?.city}}
                    </div>
                  </td>

                  <td class="StateTd">
                    {{ revenueReportList?.state }}
                  </td>
                  <td class="countryTD">
                    {{ revenueReportList?.country }}
                  </td>
                  <td class="registrationDateTD">
                    {{ revenueReportList?.academySubscriptionFee | number:'0.2-2' }}
                  </td>
                  <td class="userSubscriptionFeeTD">
                    {{ revenueReportList?.userSubscriptionFee | number:'0.2-2' }}
                  </td>
                  <td class="userNameTD">
                    {{ revenueReportList?.tournamentRegistrations | number:'0.2-2' }}
                  </td>
                  <td class="BookingsTd">
                    {{ revenueReportList?.courtBookings | number:'0.2-2' }}
                  </td>
                  <td class="userNameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ revenueReportList?.academyRegistration | number:'0.2-2' }}
                  </td>
                  <td class="userNameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ revenueReportList?.findAPartner | number:'0.2-2' }}
                  </td>
                  <td class="userNameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ revenueReportList?.eStore }}
                  </td>
                  <td class="userNameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ revenueReportList?.totalRevenue | number:'0.2-2' }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">

                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Revenue list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
